import { c as _c } from "react/compiler-runtime";
import React, { useState, useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import { components } from 'react-select';
import classNames from 'classnames';
import BaseSelectField from 'components/essentials/BaseSelectField';
import { PDP_READYTOSHIP_TAB_ID } from 'commons/constants';
import usePdpSelectedCustomizerTab from '../state/pdpSelectedCustomizerTab/usePdpSelectedCustomizerTab';
import usePDPOptions from '../state/context/usePDPOptions';
const Option = props => {
  const $ = _c(11);
  const {
    hasRightValue,
    rightFieldName
  } = props;
  if (!hasRightValue) {
    let t0;
    if ($[0] !== props) {
      t0 = <div className="text-sm font-bold text-[#333] flex border-gray-light6 cursor-pointer relative hover:border-gray-light1 hover:shadow-none"><components.Option {...props} /></div>;
      $[0] = props;
      $[1] = t0;
    } else {
      t0 = $[1];
    }
    return t0;
  }
  let t0;
  if ($[2] !== props.getValue) {
    t0 = props.getValue();
    $[2] = props.getValue;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  const selectedValue = t0;
  let t1;
  if ($[4] !== props) {
    t1 = <components.Option {...props} />;
    $[4] = props;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const t2 = selectedValue[rightFieldName];
  let t3;
  if ($[6] !== t2) {
    t3 = <span>{t2}</span>;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t1 || $[9] !== t3) {
    t4 = <div className="flex flex-row items-center justify-between">{t1}{t3}</div>;
    $[8] = t1;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
};
Option.propTypes = {
  hasRightValue: PropTypes.bool,
  rightFieldName: PropTypes.string,
  getValue: PropTypes.func
};
const SingleValue = props => {
  const $ = _c(11);
  const pdpSelectedCustomizerTab = usePdpSelectedCustomizerTab();
  const {
    stockDisabledStatus: t0,
    getValue
  } = props;
  let isDisabled;
  let t1;
  if ($[0] !== getValue || $[1] !== pdpSelectedCustomizerTab || $[2] !== t0) {
    const stockDisabledStatus = t0 === undefined ? {} : t0;
    const selectedValue = getValue();
    const finalValue = selectedValue ? Array.isArray(selectedValue) ? selectedValue[0] : selectedValue : {};
    isDisabled = pdpSelectedCustomizerTab === PDP_READYTOSHIP_TAB_ID && stockDisabledStatus[finalValue?.value];
    t1 = classNames({
      "cursor-not-allowed [&_.react-select\\_\\_single-value]:text-gray-light4": isDisabled
    });
    $[0] = getValue;
    $[1] = pdpSelectedCustomizerTab;
    $[2] = t0;
    $[3] = isDisabled;
    $[4] = t1;
  } else {
    isDisabled = $[3];
    t1 = $[4];
  }
  let t2;
  if ($[5] !== isDisabled || $[6] !== props) {
    t2 = <components.SingleValue isDisabled={isDisabled} {...props} />;
    $[5] = isDisabled;
    $[6] = props;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== t1 || $[9] !== t2) {
    t3 = <div className={t1}>{t2}</div>;
    $[8] = t1;
    $[9] = t2;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3;
};
SingleValue.propTypes = {
  stockDisabledStatus: PropTypes.object,
  getValue: PropTypes.func
};
const PDPTextDropdownOptionGroup = ({
  optionId,
  hasRightValue = false,
  rightFieldName = ''
}) => {
  const {
    data = {},
    actions
  } = usePDPOptions();
  const pdpSelectedCustomizerTab = usePdpSelectedCustomizerTab();
  const [selectedOption, setSelectedOption] = useState(null);
  const {
    options = [],
    selectedOptions = {},
    stock = {}
  } = data;
  const {
    stockOptions = [],
    stockOptionsDisabledStatus = {}
  } = stock;
  const values = useMemo(() => {
    const finalOptions = pdpSelectedCustomizerTab === PDP_READYTOSHIP_TAB_ID ? stockOptions : options;
    if (!finalOptions || !optionId || !selectedOptions) {
      return [];
    }
    const selectedOptionVal = finalOptions.find(option => option.id === optionId);
    if (!selectedOptionVal) {
      return [];
    }
    const updatedValues = selectedOptionVal.values.map(optionValue => ({
      value: optionValue.id,
      label: optionValue.value.trim(),
      rightValue: `$${optionValue.additional_cost}`,
      isDisabled: pdpSelectedCustomizerTab === PDP_READYTOSHIP_TAB_ID && stockOptionsDisabledStatus[optionValue.id]
    }));
    return updatedValues;
  }, [options, stockOptions, stockOptionsDisabledStatus, selectedOptions, pdpSelectedCustomizerTab, optionId]);
  const defaultSelectionValue = useMemo(() => {
    if (!values?.length || !data?.selectedOptionsExtended) {
      return {};
    }
    return values.find(val => `${val.value}` === `${data.selectedOptionsExtended?.[optionId]?.value?.id}`) || {};
  }, [values, data?.selectedOptionsExtended, optionId]);
  useEffect(() => {
    if (!selectedOptions || !values.length) {
      return;
    }
    const newSelOption = values.find(val_0 => `${val_0.value}` === `${selectedOptions?.[optionId]}`);
    if (!selectedOption || newSelOption && newSelOption.value !== selectedOption.value) {
      setSelectedOption(newSelOption);
    }
  }, [selectedOptions, values, optionId, selectedOption]);
  const handleChange = optionValue_0 => {
    actions.onOptionValueSelection(optionId, optionValue_0.value);
  };
  const optionName = options?.find(option_0 => option_0.id === optionId)?.name;
  return <div className="flex flex-col w-full">
      <div className="text-sm w-full font-bold text-gray-dark p-0 mt-0 mx-0 mb-1.5">
        {optionName ? `Select ${optionName}` : ''}
      </div>

      <div>
        {values.length ? <BaseSelectField
      // We use a custom className here to support overriding nested
      // third party styles in globals-tailwind.css
      className="pdp-dropdown-field" options={values} onChange={handleChange} value={selectedOption} customComponents={{
        Option: props => <Option hasRightValue={hasRightValue} rightFieldName={rightFieldName} {...props} />,
        SingleValue: props_0 => <SingleValue stockDisabledStatus={stock?.stockOptionsDisabledStatus} {...props_0} />
      }} defaultValue={defaultSelectionValue} ariaLabel="Options Dropdown" /> : null}
      </div>
    </div>;
};
PDPTextDropdownOptionGroup.propTypes = {
  optionId: PropTypes.number,
  hasRightValue: PropTypes.bool,
  rightFieldName: PropTypes.string
};
export default PDPTextDropdownOptionGroup;